/* eslint-disable no-unused-vars */
import {
    PAYMENT_INPUT,
    PAYMENT_LOADER,
    SETTINGS,
    STORE_INPUTS,
    UPDATE_PAYMENT_METHOD,
    VENDOR_PREFERENCE,
} from './settingsTypes';

// settings initial states

const initialState = {
    preferences: {},
    settings: {},
    payment_loader: false,
};

const settingsReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case VENDOR_PREFERENCE:
            return {
                ...state,
                preferences: payload,
            };
        case SETTINGS:
            return {
                ...state,
                settings: payload,
            };
        case STORE_INPUTS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    [payload.name]: payload.value,
                },
            };
        case PAYMENT_INPUT:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    payment: {
                        ...state.settings.payment,
                        [payload.section]: {
                            ...state.settings.payment[payload.section],
                            [payload.name]: payload.value,
                        },
                    },
                },
            };
        case UPDATE_PAYMENT_METHOD:
            return {
                ...state,
            };
        case PAYMENT_LOADER:
            return {
                ...state,
                payment_loader: payload,
            };

        default:
            return state;
    }
};

export default settingsReducer;
